<div class="form-input-container" [style]="style">
  @if (label) {
    <label>{{label}}</label>
  }

  <div
    class="radiobox-container"
    [style.flex-direction]="displayDirection == 'vertical' ? 'column' : 'row'"
    [style.gap]="'0.75rem'"
    [style.justify-content]="'flex-start'"
  >
    @for (item of options; track item.id) {
      <div style="display:flex;">
        <input
          type="radio"
          [id]="optionId(item)"
          [name]="radioName"
          [value]="item.id"
          [checked]="boundValue == item.id"
          [disabled]="disabled || readonly"
          (change)="handleOnChanged(item.id)"
        />
        <label [for]="optionId(item)" style="padding-right: 5px; padding-left: 5px; padding-top: 5px; font-family: Booton; font-weight: 400; font-size: 12px; color: var(--green-800);">{{item.name}}</label>
      </div>
    }
  </div>

  <div class="validation-msg" [hidden]="isValid">{{validationMsg}}</div>
</div>
